// `spin-wheel` works out the rotation that parks the target slice under the pointer, then
// adds `rotations * 360` on top of it (src/wheel.js, spinToItem). A whole number of turns
// leaves the target where it was; a fraction of a turn slides the wheel on by that fraction
// and it rests on a different slice than the one the server charged for.
const FALLBACK_TURNS = 6;

export function spinTurns(rotations) {
    const turns = Math.round(Number(rotations));

    return Number.isInteger(turns) && turns > 0 ? turns : FALLBACK_TURNS;
}
